import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

/* The plain bordered input, used where a Field's legend would be redundant —
   search boxes, table filters, inline edits. */
export function Input({ className, ...props }: ComponentProps<'input'>) {
  return (
    <input
      className={cn(
        'h-control w-full rounded-hk border border-input-border bg-input px-3',
        'text-sm text-foreground font-sans outline-none placeholder:text-muted-fg',
        'focus:border-[#7dd3fc] focus:ring-3 focus:ring-[color-mix(in_oklab,#7dd3fc_35%,transparent)]',
        'disabled:opacity-60 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  )
}
